const ReportNames = {
    "counters_day": "Liczniki na dzień",
    "counters_range": "Liczniki na okres",
    "consumables_range": "Wymiany materiałów eksploatacyjnych"
}

export {
    ReportNames
}